export default "__VITE_ASSET__egPWfS6g__"